import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _find from 'lodash/find';
import _range from 'lodash/range';
import { INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK_CLICKTHROUGH, INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK_CLICKTHROUGH } from '../../../interactions/constants';
import { getCategoryItems } from '../../services/catalog';
export function getScheduleCategories(schedules, categories) {
  return schedules.reduce(function (allCategories, _ref) {
    var scheduleCategories = _ref.categories;
    return [].concat(_toConsumableArray(allCategories), _toConsumableArray(scheduleCategories.map(function (categoryId) {
      return _find(categories, function (_ref2) {
        var _id = _ref2._id;
        return _id === categoryId;
      });
    })));
  }, []).filter(function (category) {
    return category;
  });
}
export function getCategoryProps(category, parentProps) {
  var _parentProps$catalog = parentProps.catalog,
    _parentProps$catalog$ = _parentProps$catalog.items,
    items = _parentProps$catalog$ === void 0 ? [] : _parentProps$catalog$,
    modifierSets = _parentProps$catalog.modifierSets,
    modifiers = _parentProps$catalog.modifiers,
    defaultAllOpen = parentProps.defaultAllOpen;
  return {
    category: category,
    items: getCategoryItems(category, items),
    modifierSets: modifierSets,
    modifiers: modifiers,
    open: defaultAllOpen ? true : null
  };
}
export function getInitialActiveIndices(initialActiveIndices, categories, defaultAllOpen) {
  if (categories.length <= 1) {
    return [0];
  }
  return defaultAllOpen ? _range(categories.length) : initialActiveIndices;
}
export function getInteractions(interactions) {
  return (interactions || []).filter(function (interaction) {
    return interaction.url;
  });
}
export function interactionIsClickthrough(interaction) {
  var clickThroughTypes = [INTERACTION_BEHAVIOR_TYPE_INTERNAL_LINK_CLICKTHROUGH, INTERACTION_BEHAVIOR_TYPE_EXTERNAL_LINK_CLICKTHROUGH];
  return interaction && clickThroughTypes.includes(interaction.behaviorType);
}